export const isDevOrStageHostname = () => {
  const hostname = window.location.hostname
  return hostname.includes('localhost') || hostname.includes('.qa.paypal.com')
}
